<template>
    <order-details></order-details>
</template>

<script>
import OrderDetails from '../../components/Details/OrderDetails.vue';
import {
  checkProductsIsVirtualCard,
  checkProductsIsEVoucher,
} from '@/utils/categoryUtils';

export default {
  name: 'step6',
  components: { OrderDetails },
  computed: {
    isVirtualCard() {
      return checkProductsIsVirtualCard(this.$store.state.products.all.products[0]);
    },
    isEVoucher() {
      return checkProductsIsEVoucher(this.$store.state.products.all.products[0]);
    },
  },

};
</script>

<style scoped>

</style>
